import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

import 'moment/locale/sv';

export default function Form({
  children,
  style,
  postUrl,
  form,
  novalidate,
  clearOnSubmit,
  reloadOnSubmit,
  jsonData,
  isAuthorizedBroker,
  setShowError,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
  postUrl: string;
  form: UseFormReturn<FieldValues>;
  novalidate?: boolean;
  clearOnSubmit?: boolean;
  reloadOnSubmit?: boolean;
  jsonData?: boolean;
  isAuthorizedBroker?: boolean;
  setShowError?(val: boolean): void;
}): JSX.Element {
  const { reset, setError, handleSubmit, clearErrors } = form;

  if (isAuthorizedBroker && setShowError != undefined) {
    novalidate = true;
  }
  async function onSubmit(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formValues: any
  ): Promise<void> {
    const resp = await fetch(postUrl, {
      method: 'POST',
      body: jsonData
        ? JSON.stringify(formValues)
        : convertToFormData(formValues),
      headers: jsonData
        ? { 'Content-Type': 'application/json' }
        : { Accept: '*/*' },
    });
    if (resp.ok) {
      if (clearOnSubmit !== false) {
        reset();
      } else if (reloadOnSubmit === true) {
        window.location.reload();
      }
    } else {
      const serverErrorMessage = await parseServerErrorMsg(resp);

      setError('serverError', {
        type: 'manual',
        message: serverErrorMessage,
      });
    }
  }
  function handleClick() {
    setShowError(true);
  }

  return (
    <FormProvider {...form}>
      <form
        encType={jsonData ? 'application/json' : 'multipart/form-data'}
        style={style}
        onSubmit={
          isAuthorizedBroker === true && setShowError != undefined
            ? handleSubmit(handleClick)
            : handleSubmit(onSubmit)
        }
        onChange={() => clearErrors('serverError')}
        noValidate={novalidate}
      >
        {children}
      </form>
    </FormProvider>
  );
}

async function parseServerErrorMsg(resp: Response) {
  let serverError = 'Server error: see log for more info';

  if (resp.headers.get('content-type')?.includes('application/json')) {
    const data = await resp.json();
    serverError = data.Message || serverError;
  } else {
    const text = await resp.text();

    if (text && text.length < 100) {
      serverError = text;
    }
  }

  return serverError;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function convertToFormData(formValues: any): FormData {
  const formData = new FormData();
  Object.keys(formValues).forEach((key) => {
    if (!formValues[key]) return; // dont include field with without value

    if (typeof formValues[key] === 'object') {
      const maybeFileList = formValues[key];
      if (maybeFileList.item && maybeFileList.item(0)) {
        formData.append(key, maybeFileList.item(0) as Blob);
      } else if (maybeFileList[0]) {
        formData.append(key, maybeFileList[0] as Blob);
      } else {
        // Array med strings
        formData.append(key, JSON.stringify(formValues[key]));
      }
    } else {
      formData.append(key, formValues[key]);
    }
  });
  return formData;
}
